import axios from './axios'
import qs from 'qs';
let userBastUrl = '/api/user/';
/**
 *
 *
 */
export default {
  // 获取用户信息
  getUserPersonalData(data) {
    return axios.get(userBastUrl + 'userInfo', {
      params: data
    });
  },
  getAdminUsers(data) {
    return axios.get(userBastUrl + 'getAdminUsers', {
      params: data
    });
  },
  getUsers(data) {
    return axios.get(userBastUrl + 'getUsers', {
      params: data
    });
  },
  editUser(data) {
    return axios.get(userBastUrl + 'editUser', {
      params: data
    });
  },
  getRoleEnum(data) {
    return axios.get(userBastUrl + 'getRoleEnum', {
      params: data
    });
  },
}
